import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "" }) {
  return (
    <Link to="/" className={`block ${className}`} aria-label="Nourish Natural Health Clinic Home" data-testid="site-logo-link">
      <img
        src="/images/logo.jpg"
        alt="Nourish Natural Health Clinic"
        className="w-full h-auto"
        width="540"
        height="216"
        data-testid="site-logo-img"
      />
    </Link>
  );
}
